var scope_0 = require('/vercel/5a279571/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0dfe570f8a1287e859cd29f111542994.js').default;
var scope_1 = require('/vercel/5a279571/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/186b0ef1c2405a71fcc066befaa6b0e0.js').default;
var scope_2 = require('/vercel/5a279571/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e683cd632f01f4cc1702ebee6df28d62.js').default;
var scope_3 = require('/vercel/5a279571/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    